export enum CancelVisitReasonEnum {
        ParentForwardSlashPatientrequest = 5197,
        Officecancelled = 5198,
        Noshow = 5199,
        Other = 5200,
        Officereschedule = 5201,
}
